/**
 * EMU Invoice API
 * EMU Invoice API documentation<br> Do not use 403 status, use 409 instead<br>
 *
 * OpenAPI spec version: 1.0.5
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { DbDefaultResponse } from '../model/dbDefaultResponse';
import { InvoiceDataDto } from '../model/invoiceDataDto';
import { InvoiceDataRequest } from '../model/invoiceDataRequest';
import { InvoiceDto } from '../model/invoiceDto';
import { InvoiceListResponseDto } from '../model/invoiceListResponseDto';
import { InvoiceNumberDto } from '../model/invoiceNumberDto';
import { InvoiceNumberGetDto } from '../model/invoiceNumberGetDto';
import { InvoiceSaveDto } from '../model/invoiceSaveDto';
import { ListFilterRequestDto } from '../model/listFilterRequestDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class InvoiceService {
  protected basePath = 'http://127.0.0.1:4201/api/';

  public defaultHeaders = new HttpHeaders();

  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   *
   * @param id
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<DbDefaultResponse>;
  public invoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<DbDefaultResponse>>;
  public invoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<DbDefaultResponse>>;
  public invoiceControllerDelete(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling invoiceControllerDelete.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<DbDefaultResponse>(
      'delete',
      `${this.basePath}/invoice/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param id
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<InvoiceDto>;
  public invoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<InvoiceDto>>;
  public invoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<InvoiceDto>>;
  public invoiceControllerGet(
    id: number,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling invoiceControllerGet.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InvoiceDto>(
      'get',
      `${this.basePath}/invoice/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Prepare new invoice
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceControllerGetInvoice(
    body: InvoiceDataRequest,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<InvoiceDataDto>;
  public invoiceControllerGetInvoice(
    body: InvoiceDataRequest,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<InvoiceDataDto>>;
  public invoiceControllerGetInvoice(
    body: InvoiceDataRequest,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<InvoiceDataDto>>;
  public invoiceControllerGetInvoice(
    body: InvoiceDataRequest,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling invoiceControllerGetInvoice.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<InvoiceDataDto>('post', `${this.basePath}/invoice/get`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get next invoice number without increasing counter
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceControllerGetInvoiceNumber(
    body: InvoiceNumberGetDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<InvoiceNumberDto>;
  public invoiceControllerGetInvoiceNumber(
    body: InvoiceNumberGetDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<InvoiceNumberDto>>;
  public invoiceControllerGetInvoiceNumber(
    body: InvoiceNumberGetDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<InvoiceNumberDto>>;
  public invoiceControllerGetInvoiceNumber(
    body: InvoiceNumberGetDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling invoiceControllerGetInvoiceNumber.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<InvoiceNumberDto>('post', `${this.basePath}/invoice/number`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<InvoiceListResponseDto>;
  public invoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<InvoiceListResponseDto>>;
  public invoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<InvoiceListResponseDto>>;
  public invoiceControllerList(
    body: ListFilterRequestDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling invoiceControllerList.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<InvoiceListResponseDto>(
      'post',
      `${this.basePath}/invoice/list`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   *
   * @param body
   * @param x_organization
   * @param x_apigateway_event
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public invoiceControllerSave(
    body: InvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<any>;
  public invoiceControllerSave(
    body: InvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<any>>;
  public invoiceControllerSave(
    body: InvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<any>>;
  public invoiceControllerSave(
    body: InvoiceSaveDto,
    x_organization?: any,
    x_apigateway_event?: any,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling invoiceControllerSave.',
      );
    }

    let headers = this.defaultHeaders;
    if (x_organization !== undefined && x_organization !== null) {
      headers = headers.set('x-organization', String(x_organization));
    }
    if (x_apigateway_event !== undefined && x_apigateway_event !== null) {
      headers = headers.set('x-apigateway-event', String(x_apigateway_event));
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>('post', `${this.basePath}/invoice`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
